<template>
  <div class="not-found">
    <div class="not-found__content">
      <p>
        Sorry, it looks like we couldn't find what you're looking for
        <br />Click the button below to go back
      </p>
      <v-btn @click="back">Return to the app</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",

  methods: {
    back() {
      this.router.push("/");
    }
  }
};
</script>

<style scoped lang="sass">
@import "@/styles/mixins.sass"
.not-found
    width: 100%
    height: 100%
    text-align: center

    &__content
        @include absolute-center

p
    font-size: 30px
</style>